(function(){
  if(window.__beaZoom)return;window.__beaZoom=true;
  var SEL='media-gallery img';
  var ATC='.add-to-cart-button, add-to-cart-component button';
  var BUY='.shopify-payment-button__button, accelerated-checkout button';
  var fine=window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('click',function(e){
    var b=e.target.closest(ATC);
    if(b){b.classList.add('bea-flash');setTimeout(function(){b.classList.remove('bea-flash');},1400);return;}
    var y=e.target.closest(BUY);
    if(y){y.classList.add('bea-flash-buy');setTimeout(function(){y.classList.remove('bea-flash-buy');},1400);}
  });

  function box(img){return img.closest('li, slideshow-slide, .product-media-container')||img.parentElement;}
  function mark(img){if(img.getBoundingClientRect().width<120)return null;var b=box(img);b.classList.add('bea-zb');return b;}
  function markAll(){document.querySelectorAll(SEL).forEach(mark);}
  markAll();setTimeout(markAll,800);setTimeout(markAll,2500);

  function origin(b,x,y){
    var img=b.querySelector('img');if(!img)return;
    var r=b.getBoundingClientRect();
    var px=Math.max(0,Math.min(100,((x-r.left)/r.width)*100));
    var py=Math.max(0,Math.min(100,((y-r.top)/r.height)*100));
    img.style.transformOrigin=px+'% '+py+'%';
  }
  function clearAll(except){
    document.querySelectorAll('.bea-zb.is-zoom').forEach(function(z){if(z!==except)z.classList.remove('is-zoom');});
  }

  /* Escritorio: el zoom se activa solo con pasar el mouse */
  document.addEventListener('mousemove',function(e){
    if(!fine.matches)return;
    var g=e.target.closest('media-gallery');
    if(!g){clearAll(null);return;}
    var b=e.target.closest('.bea-zb');
    if(!b){var im=e.target.closest(SEL);if(im)b=mark(im);}
    if(!b){clearAll(null);return;}
    clearAll(b);
    origin(b,e.clientX,e.clientY);
    b.classList.add('is-zoom');
  });
  document.addEventListener('mouseleave',function(){clearAll(null);});

  /* Celular: tocar para agrandar y arrastrar para recorrer */
  document.addEventListener('click',function(e){
    if(fine.matches)return;
    var g=e.target.closest('media-gallery');if(!g)return;
    var list=document.elementsFromPoint(e.clientX,e.clientY);
    var img=null;
    for(var i=0;i<list.length;i++){if(list[i].tagName==='IMG'&&g.contains(list[i])){img=list[i];break;}}
    if(!img)return;
    var b=mark(img);if(!b)return;
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    if(b.classList.contains('is-zoom')){b.classList.remove('is-zoom');}
    else{origin(b,e.clientX,e.clientY);b.classList.add('is-zoom');}
  },true);
  document.addEventListener('touchmove',function(e){
    var b=document.querySelector('.bea-zb.is-zoom');
    if(!b||fine.matches||!e.touches.length)return;
    e.preventDefault();origin(b,e.touches[0].clientX,e.touches[0].clientY);
  },{passive:false});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')clearAll(null);});
})();
